import { Divider, Menu } from 'antd';
import { styled } from 'styled-components';
import { blockStyle } from '../styles/Block';
import layoutStyle from '../styles/Layout';

export const SideBarBlock = styled.aside`
  ${blockStyle}
  background-color: #ffffff;
`;

export const SideBarLayout = styled.nav`
  ${layoutStyle}
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 24px;
`;

export const MenuSection = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: column;
  flex: 1;
  height: auto;
`;

// Ant Design Menu の border-inline-end は詳細度が高く && では上書きできないため !important を使用
export const StyledMenu = styled(Menu)`
  border-inline-end: none !important;
`;

export const StyledDivider = styled(Divider)`
  && {
    margin: 0;
  }
`;
